<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div class="card-header">
      <h3 class="text-black fw-semibold">Liste des offres</h3>
    </div>
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
    >
      <div class="d-sm-flex align-items-center">
        <router-link
          class="btn btn-primary"
          to="/ajouter-offre"
        >
          <i class="fa fa-plus-circle"></i>
          Ajouter une offre
        </router-link>
        
      </div>
      <div class="d-flex align-items-center">
        <form class="search-box position-relative" @submit.prevent="rechercher">
          <input
            type="text"
            v-model="searchTerm"
            @keyup="rechercher"
            class="form-control shadow-none text-black rounded-0 border-0"
            placeholder="Rechercher une offre"
          />
          <button type="submit" class="bg-transparent text-primary transition p-0 border-0">
            <i class="flaticon-search-interface-symbol"></i>
          </button>
        </form>
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
               <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Catégorie
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Titre
              </th>
             <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Description
              </th>
             <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Salaire
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Date Publication
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
              Date Expiration
              </th>
               <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text pe-0"
              >ACTIONS</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(offre, index) in offres" :key="index">
               <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ offre?.categorieOffre?.libelle }}
              </td>
               <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ offre.titre }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis p-2"
                style="max-width: 300px; word-wrap: break-word; white-space: normal;">
                {{ offre.description  }}
              </td>
               
               <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ separateur(offre.salaire) }}
              </td>
               <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ format_Date(offre.datePublication) }}
              </td>
               <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ format_Date(offre.dateExpiration) }}
              </td>
              
              <td
                class="shadow-none lh-1 fw-medium text-body-tertiary text pe-0"
              >
               <div class="dropdown">
              <span class="badge text-white bg-primary fs-15 dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                      Actions
                      <i class="flaticon-chevron-2 position-relative ms-5 top-2 fs-15"></i>
                  </span>
                  <ul class="dropdown-menu dropdown-block" style="position: absolute; inset: 0px auto auto 0px; margin: 0px; transform: translate(267px, 305px);" data-popper-placement="bottom-start">
                    <li class="dropdown-item d-flex align-items-center">
                      <router-link :to="{ name: 'EditOffrePage', params: { id: offre.id } }" 
                          class="dropdown-item d-flex align-items-center"><i
                          class="flaticon-pen lh-1 me-8 position-relative top-1"
                        ></i>Modifier</router-link>
                    </li>
                    <li class="dropdown-item d-flex align-items-center">
                        <router-link :to="{ name: 'ViewOffrePage', params: { id: offre.id } }" class="dropdown-item d-flex align-items-center">
                            <i class="flaticon-eye lh-1 me-8 position-relative top-1"></i>Détails
                        </router-link>
                    </li>
                    <li class="dropdown-item d-flex align-items-center">
                        <router-link :to="{ name: 'CandidatureOffrePage', params: { id: offre.id } }" class="dropdown-item d-flex align-items-center">
                            <i class="flaticon-eye lh-1 me-8 position-relative top-1"></i>Candidats
                        </router-link>
                    </li>
                     <li class="dropdown-item d-flex align-items-center">
                        <router-link :to="{ name: 'AvisOffrePage', params: { id: offre.id } }" class="dropdown-item d-flex align-items-center">
                            <i class="flaticon-eye lh-1 me-8 position-relative top-1"></i>Avis
                        </router-link>
                    </li>
                    <li class="dropdown-item d-flex align-items-center" >
                      <a
                        class="dropdown-item d-flex align-items-center" href="javascript:void(0);" @click="suppression(offre.id,offres,'offres',`l\'offre ${offre.titre}`)">
                        <i class="fa fa-trash-o lh-1 me-8 position-relative top-1" ></i>
                         Supprimer
                      </a>
                    </li>
                  </ul>
                  </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center"
      >
        <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit" @paginate="handlePaginate" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref} from "vue";
import Swal from "sweetalert2";
import { Offre } from "@/models/Offre";
import ApiService from "@/services/ApiService";
import { suppression, error,separateur, format_Date } from "@/utils/utils";
import PaginationComponent from '@/components/Utilities/Pagination.vue';
import JwtService from "@/services/JwtService";
import { format } from "path";

export default defineComponent({
  name: "ListeOffre",
  components: {
    PaginationComponent
  },
  setup(){
    
    onMounted(() => {
      getAllOffre();
    });

    const offres = ref<Array<Offre>>([]);   
    const offre = ref<Offre>();

    // BEGIN PAGINATE
    const searchTerm = ref('');
    const page = ref(1);
    const totalPages = ref(0);
    const limit = ref(10);
    const totalElements = ref(0);

    const handlePaginate = ({ page_, limit_ }) => {
      try {
        page.value = page_;
        getAllOffre(page_, limit_);
      } catch (error) {
        //
      }
    };

     function rechercher(){
      getAllOffre(page.value, limit.value, searchTerm.value );
    }

    // END PAGINATE

    function getAllOffre(page = 1, limi = 10, searchTerm = '') {
      return ApiService.get(`/offres?page=${page}&limit=${limi}&searchTerm=${searchTerm}&`)
        .then(({ data }) => {
          offres.value = data.data.data;
          totalPages.value = data.data.totalPages;
          limit.value = data.data.limit;
          totalElements.value = data.data.totalElements;
          return data.data;
        })
        .catch(({ response }) => {
          error(response.data.message)
      });
    }
    
    function moddifier(Editoffres:Offre) {
      offre.value = Editoffres;
    }

    const deleteOffre = (id: number) => {
      ApiService.delete(`/offres/${id}`)
      .then(({ data }) => {
        Swal.fire({
          text: data.message,
          toast: true,
          icon: 'success',
          title: 'General Title',
          animation: false,
          position: 'top-right',
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
          heightAuto: false
        });
      })
      .catch(({ response }) => {
        Swal.fire({
          text: response.data.message,
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "Réssayer à nouveau!",
          heightAuto: false,
          customClass: {
            confirmButton: "btn fw-semobold btn-light-danger",
          },
        });
      });

      for(let i = 0; i < offres.value.length; i++) {
        if (offres.value[i].id === id) {
          offres.value.splice(i, 1);
        }
      }
    };

    const privileges = ref<Array<string>>(JwtService.getPrivilege());

    const checkPermission = (name) => {
      return privileges.value.includes(name);
    }

    return { offres,
      checkPermission,
     getAllOffre,
     deleteOffre,
     moddifier ,
     suppression,
     page, 
    totalPages,
    limit,
    totalElements,
    handlePaginate,
    rechercher,separateur, format_Date,
    searchTerm
  };
  },
});
</script>